<template>
  <div>
    <color-picker class="area-color-picker" title="区块颜色" :color.sync="areaColor" />
    <color-picker class="mt16 area-color-picker" title="选中颜色" :color.sync="selectColor" />
    <color-picker class="mt16 area-color-picker" title="边界颜色" :color.sync="primaryBorderColor" />
    <div class="mt16">
      <p>边界宽度</p>
      <slider-and-input
        class="mt8"
        :value.sync="primaryBorderWidth"
        titlePosition="singleLine"
        :sliderMax="20"
        suffix="px"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: { options: Object },
  computed: {
    ids() {
      return this.myid
    },
    chartOption() {
      return this.options.chartOption
    },
    areaColor: {
      get() {
        return this.chartOption.areaColor
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.areaColor", false)
      }
    },
    primaryBorderColor: {
      get() {
        return this.chartOption.primaryBorderColor
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.primaryBorderColor", false)
      }
    },
    selectBorderColor: {
      get() {
        return this.chartOption.selectBorderColor
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.selectBorderColor", false)
      }
    },
    selectColor: {
      get() {
        return this.chartOption.selectColor
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.selectColor", false)
      }
    },
    primaryBorderWidth: {
      get() {
        return this.chartOption.primaryBorderWidth
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.primaryBorderWidth", false)
      }
    },
    selectBorderWidth: {
      get() {
        return this.chartOption.selectBorderWidth
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.selectBorderWidth", false)
      }
    }
  }
}
</script>

<style scoped>
.area-color-picker/deep/.text {
  flex: 0 0 auto;
}
</style>
